import { Box, Link, styled } from '@mui/material';
import CustomTypography from '@/components/Common/Typography';
import { corePalette } from '@/themes/colours';
import { POPUP_TEXT_SIZE } from '@/constants/PatientDashboard/patientTimeline';

export const ExternalLink = styled(Link)({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
  color: corePalette.green150,
  textDecoration: 'none',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  '& svg': {
    width: '16px',
    height: '16px',
  },
});

export const PopupRowText = styled(CustomTypography)({
  fontSize: POPUP_TEXT_SIZE,
  lineHeight: '18px',
  fontWeight: 500,
  color: corePalette.grey200,
});

export const PopupRowName = styled(PopupRowText)({
  flex: 1,
  minWidth: 0,
});

export const PopupRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  minWidth: 0,
});

export const PopupValueCell = styled(Box)({
  flexShrink: 0,
  fontSize: '12px',
  lineHeight: '140%',
  textAlign: 'right',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
